import { makeStyles } from '@material-ui/core';
export const useStyles = makeStyles({
    statusWrapper: {
        width: '100%',
        display: 'grid',
        padding: '4px 12px',
        paddingRight: '15px',
        borderRadius: '50px',
        gridTemplateColumns: 'max-content 1fr',
        columnGap: '10px',
        alignItems: 'center',
        fontWeight: 600,
        lineHeight: '24px',
        color: '#fff',
        '& path': {
            fill: '#fff',
        },
        maxWidth: 'max-content',
        marginLeft: '22px',
    },
    container: {
        padding: '8px 12px',
        display: 'grid',
        gridTemplateColumns: '265px 1fr 1fr 1fr 100px',
        rowGap: '40px',
        columnGap: '20px',
        boxShadow:
            '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
        marginTop: '10px',
        alignItems: 'center',
        minHeight: '64px',
    },
    actionsContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
});
